import {
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   OnChanges,
   OnDestroy,
   Output,
   SimpleChanges,
} from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DefaultReportParameterComponentAccessor } from './report-parameter-component-accessor';
import { ReportParameterFormService } from './services/report-parameter-form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-report-parameters-list',
    styleUrls: ['./report-parameters-list.component.scss'],
    templateUrl: './report-parameters-list.component.html',
    standalone: false
})
// eslint-disable-next-line @typescript-eslint/naming-convention
export class ReportParametersListComponent<P> implements OnChanges, OnDestroy {
   @Input() formService: ReportParameterFormService<P>;

   @Output() formChange = new EventEmitter<void>();

   componentAccessor = DefaultReportParameterComponentAccessor;

   get parameters(): AbstractControl[] {
      return (this.form?.controls?.values as UntypedFormArray)?.controls || [];
   }

   form: UntypedFormGroup = new UntypedFormGroup({});

   private destroyed$ = new Subject<void>();

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.formService && this.formService) {
         this.form = this.formService.form;

         this.form.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((v) => {
            this.formChange.emit();
         });
      }
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
